import { PublicLayout } from "@/components/layout/PublicLayout";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

const Preise = () => {
  const plans = [
    {
      name: "Basic",
      originalPrice: "200€",
      price: "160€",
      description: "Für Einsteiger & Hörbuch-Held*innen",
      features: [
        "100 Credits / Monat",
        "Bis zu 10 Hörbücher",
        "Standard Publishing-Speed",
        "Sofort startklar",
      ],
      popular: false,
    },
    {
      name: "Plus",
      originalPrice: "340€",
      price: "325€",
      description: "Für Macher, die mehr Reichweite wollen",
      features: [
        "250 Credits / Monat",
        "Bis zu 25 Hörbücher",
        "Priority Credits",
        "Fastlane Upload",
        "Exklusive Platform-Boni",
      ],
      popular: true,
    },
    {
      name: "Pro",
      originalPrice: "600€",
      price: "550€",
      description: "Für Publisher & Vollprofis, die skalieren",
      features: [
        "500 Credits / Monat",
        "Bis zu 50 Hörbücher",
        "Maximale Priority Credits",
        "Premium Upload",
        "VIP Support",
      ],
      popular: false,
    },
  ];

  return (
    <PublicLayout
      showHero={true}
      heroTitle="Preise & Pakete"
      heroSubtitle="Finden Sie das perfekte Paket für Ihre Hörbuch-Produktion"
      heroVariant="compact"
      heroChildren={
        <div className="w-full max-w-7xl mx-auto px-4 mt-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {plans.map((plan, index) => (
              <Card
                key={index}
                className={`relative backdrop-blur-md border shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-3xl flex flex-col h-full ${
                  plan.popular
                    ? "bg-gray-800/40 border-gray-500/50"
                    : "bg-gray-800/30 border-gray-600/30"
                }`}
              >
                {plan.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <Badge className="bg-gray-100 text-gray-900 px-4 py-1 text-sm font-semibold">
                      Beliebteste Wahl
                    </Badge>
                  </div>
                )}

                <CardHeader className="text-center pb-4 flex-shrink-0">
                  <CardTitle className="text-2xl font-bold text-white mb-2">{plan.name}</CardTitle>
                  <div className="mb-4">
                    <div className="flex items-center justify-center space-x-2">
                      <span className="text-gray-400 line-through text-lg">
                        {plan.originalPrice}
                      </span>
                      <span className="text-4xl font-bold text-white">{plan.price}</span>
                    </div>
                    <div className="text-gray-300 text-sm mt-1">pro Monat</div>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">{plan.description}</p>
                </CardHeader>

                <CardContent className="pt-0 flex flex-col flex-1">
                  <div className="space-y-3 mb-6 flex-1">
                    {plan.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="flex items-start space-x-3">
                        <div
                          className="w-5 h-5 rounded-full flex items-center justify-center mt-0.5"
                          style={{ backgroundColor: "#ebf5ff" }}
                        >
                          <Check className="h-3 w-3 text-gray-900" />
                        </div>
                        <span className="text-gray-200 text-sm leading-relaxed">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <div className="text-center mb-6">
                    <p className="text-white font-bold text-lg">
                      {plan.name === "Basic" && "16€ pro Hörbuch"}
                      {plan.name === "Plus" && "13€ pro Hörbuch"}
                      {plan.name === "Pro" && "11€ pro Hörbuch"}
                    </p>
                  </div>

                  <Button
                    className={`w-full font-semibold py-3 text-gray-900 transition-all duration-300 mt-auto ${
                      plan.popular ? "hover:bg-opacity-90" : "hover:bg-opacity-90"
                    }`}
                    style={{ backgroundColor: "#ebf5ff" }}
                    size="lg"
                    asChild
                  >
                    <Link to="/publisher-werden">Jetzt starten</Link>
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      }
    >
      <div className="container mx-auto px-4 py-16">
        <div className="text-center">
          <h2 className="text-3xl font-bold mb-6 text-gray-900">
            Haben Sie Fragen zu unseren Paketen?
          </h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Unsere Experten helfen Ihnen gerne bei der Auswahl des passenden Pakets und beantworten
            alle Ihre Fragen.
          </p>
          <Button size="lg" className="bg-gray-900 hover:bg-gray-800 text-white px-8 py-4" asChild>
            <Link to="/contact">Kostenlose Beratung</Link>
          </Button>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Preise;
